import { uniq } from 'ramda';

import { DEALER_STATUS } from 'constants/StatusConstants';

export const changeDealerStatusSuccessReducer = (state, { payload: { id, status } }) => {
  if (status === DEALER_STATUS.ACTIVE) {
    return uniq([...state, id]);
  }
  return state.filter(dealerId => dealerId !== id);
};
